import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import CloseIcon from "../assets/img/close-white.svg";

interface ModalProps {
    openModal: boolean;
    toggleModal: () => void;
    title?: string;
    children?: any;
    footer?: any;
    needXlSize?: boolean
    size?: 'sm' | 'md' | 'lg' | 'xl';
}
const ModalComponent = ({
    openModal,
    toggleModal,
    title,
    children,
    footer,
    needXlSize,
    size
}: ModalProps) => {

    const closeIcon = (
        <img src={CloseIcon} style={{ cursor: 'pointer' }} onClick={toggleModal}></img>
    );
    return (
        <>
            <Modal
                isOpen={openModal}
                toggle={toggleModal}
                centered
                backdrop={'static'}
                size={size || (needXlSize ? 'xl' : 'lg')}
            >
                {title && <ModalHeader toggle={toggleModal}>{title}</ModalHeader>}
                <ModalBody>{children}</ModalBody>
                {footer && <ModalFooter>{footer}</ModalFooter>}
            </Modal>

        </>
    );
}


export default ModalComponent;